/**
 * Web implementation of useWebDropzone hook
 * Uses react-dropzone for drag-and-drop file upload functionality
 */
import { RefObject } from 'react'
import { FileRejection, useDropzone } from 'react-dropzone'

export interface WebDropzoneOptions {
  accept?: Record<string, string[]>
  maxSize?: number
  disabled?: boolean
  onDrop?: (acceptedFiles: File[]) => void
  onDropRejected?: (fileRejections: FileRejection[]) => void
}

export interface WebDropzoneResult {
  getRootProps: () => Record<string, unknown>
  getInputProps: () => Record<string, unknown>
  isDragActive: boolean
  inputRef: RefObject<HTMLInputElement | null>
  open: () => void
}

/**
 * Web implementation using react-dropzone
 * Provides drag-and-drop file upload functionality
 */
export const useWebDropzone = (options?: WebDropzoneOptions): WebDropzoneResult => {
  const { getRootProps, getInputProps, isDragActive, inputRef, open } = useDropzone({
    accept: options?.accept,
    maxSize: options?.maxSize,
    disabled: options?.disabled,
    onDrop: options?.onDrop,
    onDropRejected: options?.onDropRejected,
    multiple: false,
    noClick: true, // We handle click separately for better control
    noKeyboard: false,
  })

  return {
    getRootProps: getRootProps as () => Record<string, unknown>,
    getInputProps: getInputProps as () => Record<string, unknown>,
    isDragActive,
    inputRef,
    open,
  }
}
